// 抽奖转盘模块API接口

import { BaseApi } from "../../../utils/request";
import type { WheelConfig, WheelUserInfo, WheelPrizeRecord } from "../types";

export class WheelApi extends BaseApi {
  /**
   * 获取当前启用的抽奖转盘配置
   * @description 后端只返回 enabled=true 且匹配当前品牌的转盘；未启用时 model 为空
   */
  async getConfig(): Promise<WheelConfig | null> {
    const response = await this.get<WheelConfig, true>(
      "/api/wheel/config",
      {},
      {
        cache: true,
        cacheTime: 60 * 1000, // 1分钟缓存，与后端 process cache 节奏对齐
        alert: false,
      }
    );
    return (response.data as { model?: WheelConfig | null })?.model ?? null;
  }

  /**
   * 获取用户剩余抽奖次数与积分（未登录返回 0/0）
   */
  async getInfo(): Promise<WheelUserInfo> {
    const response = await this.post<WheelUserInfo, true>(
      "/api/wheel/info",
      {},
      { alert: false }
    );
    return (
      (response.data as { model?: WheelUserInfo })?.model ?? {
        wheelAmount: 0,
        count: 0,
      }
    );
  }

  /**
   * 执行一次抽奖（需登录）
   * @param wheelId 转盘 id
   * @returns 中奖记录（含 wheelPrize）；失败抛错（"You have no chance" / "wheel is closed"）
   */
  async spin(wheelId: string): Promise<WheelPrizeRecord> {
    const response = await this.post<WheelPrizeRecord, true>(
      "/api/wheel/spin",
      { id: wheelId },
      { alert: false }
    );
    return (response.data as { model: WheelPrizeRecord }).model;
  }

  /**
   * 当前登录用户本人的中奖记录（Rewards Record 用，最多 15 条，倒序）
   * @param wheelId 转盘 id
   * @description 后端按登录态过滤 userId，未登录返回空列表
   */
  async getMyRecords(wheelId: string): Promise<WheelPrizeRecord[]> {
    const response = await this.post<WheelPrizeRecord[]>(
      "/api/wheel/my_records",
      { id: wheelId },
      { alert: false }
    );
    return (
      (response.data as unknown as { list?: WheelPrizeRecord[] })?.list ?? []
    );
  }
}

export const wheelApi = new WheelApi();
